import * as React from 'react';
import { Controller, useForm } from "react-hook-form";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Divider } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import { SelectTypeInput } from './SelectTypeInput';
import { categories, doctorDegrees } from '../constant';
  
export const EducationDialog = ({
    setEducation,
    education,
    setOpenDialog,
    index,
    isEditing=false

}) => {

    const [open, setOpen] = React.useState(false);

    const {
        control,
        handleSubmit,
        formState: { errors, isDirty, isValid },
        getValues,
        setValue,
        reset
    } = useForm();

    const handleClickOpen = () => {
        const educationData = education?.[index];
        reset({
            qualification : educationData?.qualification || '',
            category: educationData?.category || '',
          });
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        reset();
    };


    const handleSubmitForm = (field) => {
        const data = getValues();
        setOpen(false);
        if(isEditing){
            setEducation(education.map((item, i) => i === index ? { ...item, ...data } : item));
        }
        else{
            setEducation([...education, data]);
        }
        reset();
    };


    return (
        <React.Fragment>
            {
                !isEditing ? (<button className=" flex p-2 border rounded-lg border-blue-500 text-sm text-semibold text-blue-700 gap-1 " onClick={(e) => { e.preventDefault(); handleClickOpen() }}>
                    <img src="https://views.medibuddy.in/providerUi/assets/bluePlus.svg" alt="" />
                    <p> Add New </p>
                </button>) :
                    <img src="https://views.medibuddy.in/providerUi/assets/editIcon.svg" alt="Edit" onClick={(e) => { e.preventDefault(); handleClickOpen() }} style={{ cursor: 'pointer' }} />
            }

            <Dialog
                style={{ borderRadius: '16px' }}
                open={open}
                onClose={handleClose}
                fullWidth={true}
                maxWidth={'sm'}
                PaperProps={{
                    component: 'form',
                    style: { borderRadius: '1rem' },
                    onSubmit: (event) => {
                        event.preventDefault();
                        handleClose();
                    },
                }}
            >
                <DialogTitle>
                    <div className="text-xl font-semibold text-left text-[#47566A]">
                        Education
                    </div>

                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <div className="flex flex-col " style={{ gap: '1.5rem' }}>
                            <div className="flex flex-col ">
                                <div className="flex  text-base font-normal text-[#47566A] pb-1" style={{ width: '20vw', justifyContent: 'flex-start', }}>
                                    Qualification
                                    <p className=' text-mb-red' >*</p>
                                </div>
                                <div className="flex flex-row" style={{ gap: '1.5rem' }}>
                                    <FormControl error={!!errors.qualification}>
                                        <SelectTypeInput
                                            name={'qualification'}
                                            placeholder={'Select Qualifications'}
                                            control={control}
                                            width={'31.6rem'}
                                            height={'2.75rem'}
                                            rules={{ required: "Mandatory Information" }}
                                            options={doctorDegrees.map(degree => ({ value: degree, title: degree }))}
                                            errors={errors}
                                        />
                                    </FormControl>
                                </div>
                            </div>

                            <div className="flex flex-col ">
                                <div className="flex  text-base font-normal text-[#47566A] pb-1" style={{ width: '20vw', justifyContent: 'flex-start', }}>
                                    Category
                                    <p className=' text-mb-red' >*</p>
                                </div>
                                <div className="flex flex-row" style={{ gap: '1.5rem' }}>
                                    <FormControl error={!!errors.category}>
                                        <SelectTypeInput
                                            name={'category'}
                                            placeholder={'Select Category'}
                                            control={control}
                                            width={'31.6rem'}
                                            height={'2.75rem'}
                                            rules={{ required: "Mandatory Information" }}
                                            options={categories.map(category => ({ value: category, title: category }))}
                                            errors={errors}
                                        />
                                    </FormControl>
                                </div>
                            </div>
                        </div>
                    </DialogContentText>
                </DialogContent>
                <Divider variant='fullWidth' />

                <DialogActions>
                    <div className="flex gap-2 px-3 py-2">
                        <Button className=' border rounded-lg  text-sm text-semibold p-1  gap-1 ' variant='outlined' onClick={handleClose} style={{ color: '#252D38', borderColor: '#DBE0E6', borderRadius: '0.5rem' }}>Cancel</Button>
                        <button
                            className={`${isValid ? ' border-blue-700 text-white bg-blue-600 ' : ' bg-[#F5F7F8] border-[#DBE0E6] '} "flex flex-col justify-center py-2 px-4 border rounded-lg "`}
                            style={{ color: isValid ? 'white' : '#A4B0C0' }}
                            onClick={handleSubmit(handleSubmitForm)}                            >
                            Save Details
                        </button>
                    </div>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}